import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { STAGE_REASSURANCE } from "@/data/site";

const PHOTOS = [
  { src: "/images/stage/etape-2.jpg", alt: "Laçage et tension de la peau sur le cadre" },
  { src: "/images/stage/etape-4.jpg", alt: "Cercle de tambours en plein air, premiers battements partagés" },
  { src: `${process.env.REACT_APP_BACKEND_URL}/api/galerie/images/e3720265584c462a8eca4987edebb4ee_l.jpg`, alt: "Tambour rond terminé, laçage en croix tressée" },
];

export const StageReassurance = () => (
  <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 lg:pb-32 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-testid="stage-reassurance">
    <Reveal className="lg:col-span-6">
      <p className="eyebrow mb-6">Ce qui est compris</p>
      <h2 className="font-serif text-3xl sm:text-4xl text-bark leading-tight mb-8">Vous venez avec vos mains. <em className="not-italic text-terra">Le reste est là.</em></h2>
      <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
        {STAGE_REASSURANCE.map((p) => <li key={p} className="flex items-start gap-3 text-sm text-bark/85 leading-relaxed"><Check className="w-4 h-4 text-terra shrink-0 mt-0.5" />{p}</li>)}
      </ul>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-6 grid grid-cols-3 gap-3 lg:gap-4">
      {PHOTOS.map((p, i) => (
        <figure key={p.src} className={`rounded-2xl overflow-hidden bg-sand-dark ${i === 1 ? "aspect-[3/4] -mt-6 lg:-mt-10" : "aspect-[3/4]"}`}><img src={p.src} alt={p.alt} loading="lazy" className="w-full h-full object-cover" /></figure>
      ))}
    </Reveal>
  </section>
);
